import { Button } from 'antd';

import { LeftOutlined } from '@ant-design/icons';
import Title from 'antd/es/typography/Title';
import Table from '../../../components/Table';
import useGiveawayParticipants from './useGiveawayParticipants';

export default function GiveawayParticipants() {
    const {
        columns,
        isLoading,
        tableData,
        handleClickGoBack,
        giveaway
    } = useGiveawayParticipants();

    return (
        <>
            <div
                style={{
                    position: 'fixed',
                    display: 'flex',
                    alignItems: 'center',
                    zIndex: 99,
                    paddingTop: 24,
                    paddingBottom: 10,
                    paddingLeft: 24,
                    paddingRight: 10,
                    margin: -24,
                }}
            >
                <Button
                    type="link"
                    onClick={handleClickGoBack}
                    style={{
                        marginRight: 8,
                    }}
                >
                    <LeftOutlined />
                </Button>
                <Title level={4}>{giveaway?.description} - Participantes</Title>

            </div>
            <Table
                columns={columns}
                tableData={tableData}
                loading={isLoading}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: event => { }, // click row
                        onDoubleClick: event => { }, // double click row
                        onContextMenu: event => { }, // right button click row
                        onMouseEnter: event => { }, // mouse enter row
                        onMouseLeave: event => { },
                    }
                }}
            />
        </>
    )
}
